module.exports = __webpack_public_path__ + "img/g4.7ff17272.jpg";